/**
 * メニュー管理
 */
export default class MenuManager {
  constructor() {
    this.menu = document.querySelector('#js-global-menu');
    this.menuBtn = document.querySelector('#js-global-menu-btn');

    if (!this.menuBtn) return;

    // クリック時のイベントを登録
    this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    this.menuBtn.classList.toggle('js-is-active');

    // bodyタグにクラスを付与
    document.body.classList.toggle('is-global-menu-active');

    if (!this.menu) return;
    this.menu.classList.toggle('js-is-active');
  }
}
